import { Icon, IconProps } from "../";

export const AccountOvalIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM18.15 17.8653C18.5284 17.4687 18.6911 16.8965 18.4793 16.391C18.0531 15.3733 17.1768 14.6143 16.2388 14.0961C14.9122 13.363 13.286 13 12 13C10.714 13 9.08782 13.363 7.76117 14.0961C6.82322 14.6143 5.94694 15.3733 5.52067 16.391C5.30892 16.8965 5.47163 17.4687 5.84997 17.8653C7.39833 19.4882 9.58186 20.5 12 20.5C14.4182 20.5 16.6017 19.4882 18.15 17.8653ZM12 5.25C10.2045 5.25 8.75 6.70454 8.75 8.5C8.75 10.2955 10.2045 11.75 12 11.75C13.7955 11.75 15.25 10.2955 15.25 8.5C15.25 6.70454 13.7955 5.25 12 5.25Z"
      />
    </Icon>
  );
};
